<template>
    <footer
        v-if="
            $route.name !== 'panel-competition-stoper' &&
                $route.name !== 'panel-competition-map' &&
				$route.name !== 'panel-competition-scanner-qr' &&
                !isZenMode
        "
        class="footer"
    >
        <div class="container">
            <div class="row">
                <p>© DO:ST:AR:TU {{ time.format("YYYY") }}</p>
                <div class="footer-links">
                    <router-link
                        tag="p"
                        class="pointer footer-links__changelog"
                        :class="{ 'footer-links__changelog--unseen': hasUnseen }"
                        :to="{ name: 'panel-changelog', alias: true }"
                    >
                        <span
                            v-if="hasUnseen"
                            class="footer-links__badge"
                            aria-hidden="true"
                        />
                        lista zmian (changelog)
                    </router-link>
                    <router-link
                        tag="p"
                        class="pointer"
                        :to="{ name: 'main-landing', alias: true }"
                    >
                        regulamin platformy dostartu
                    </router-link>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        hasUnseen: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters(['time', 'isZenMode']),
    },
};
</script>

<style scoped>
.footer {
    padding: 14px 0;
    line-height: 1.43;
    font-size: 14px;
    color: var(--color-silver);
    border-top: 1px solid var(--color-bluish-grey);
}

.footer-links {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 24px;
}

.footer-links p {
    margin: 0;
}

.footer-links__changelog {
    position: relative;
}

.footer-links__changelog--unseen {
    padding-left: 14px;
}

.footer-links__badge {
    position: absolute;
    top: 50%;
    left: 0;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--color-pinky-red);
    transform: translateY(-50%);
}
</style>
